<template>
  <div>
    <van-field
        v-model="clientForm.code"
        type="text"
        name="图形验证码"
        label="图形验证码"
        placeholder="图形验证码"
        @focus="_getImageVerifyCode"
        :rules="[{ required: true, message: '请输入图形验证码' }]"
      />
      <van-image
        width="80"
        :src="clientForm.codeimg"
        alt=""
        @click="_getImageVerifyCode"
        style="margin-left: 10px; padding-top: 16px; margin-right: 20px"
      />
      <van-icon name="replay" size="30" @click="refreshCodeImg" />
    <h2>输入验证码</h2>
    <h2>验证码已发送至 {{encodedPhoneNum}}</h2>


    <van-password-input
      v-model="verifyCode"
      :length="4"
      :focused="showKeyboard"
      @focus="showKeyboard = true"
      :gutter="10"
    />
    <div style="margin: 16px">
        <van-button
          block
          round
          type="info"
          @click="verifyCodeLogin"
          :disabled="!consented"
          color="#4285C3"
        >
          获取验证码
        </van-button>
      </div>
    <van-number-keyboard
      :show="showKeyboard"
      @blur="showKeyboard = false"
      @input="onInput"
      @delete="onDelete"
    />
  </div>
</template>

<script>

import { loginWithVerifyCode } from "../../../api/userService";

export default {
  props:{
    examUuid: String,
  },
  data() {
    return {
      teleNum: sessionStorage.getItem('teleNum'),
      verifyCode: "",
      errorInfo: '',
      showKeyboard: true,
    }
  },
  computed:{
    encodedPhoneNum(){
      let reg = /^(\d{3})\d{4}(\d{4})$/;
      return this.teleNum.replace(reg, '$1****$2');
    },
    consented() {
      if(this.verifyCode.length==4){
        return true
      }
      else{
        return false
      }
    }
  },
  methods:{
    onInput(value){
      if(this.verifyCode.length<4){
        this.verifyCode +=value;
        // console.log(this.verifyCode,this.verifyCode.length);
      }else{
        return
      }
    },
    onDelete(){
      if(this.verifyCode.length>0){
        this.verifyCode = this.verifyCode.substring(0,this.verifyCode.length - 1);
        console.log(this.verifyCode)
      }
      else{
        return
      }
    },
    //提交表单 ->根据不同登录方式进行登录
    verifyCodeLogin() {
      let params = {
        teleNum: this.teleNum,
        verifyCode: this.verifyCode,
      };
      
        if (params.verifyCode == "") {
          this.$notify({ type: "warning", message: "请输入手机验证码" });
          return;
        } else {
            loginWithVerifyCode(params)
              .then((res) => {
                if (res.success) {
                  //保存token到sessionStorage
                  sessionStorage.setItem("logintoken", res.token);
                  sessionStorage.setItem("userId", res.data[0].userTeleNum);
                  this.$store.state.userId = res.data[0].userTeleNum;
                  this.$store.state.teleNum = res.data[0].userTeleNum;
                  this.$store.state.token = res.token;
                  this.$store.state.isAuthenticated = true;
                  //根据角色跳转路径
                  this.$router.push({ path: "/appIndex/main" });
                } else {
                  this.$notify({ type: "error", message: res.description });
                }
              })
              .catch((e) => {
                console.log(e);
              });
        }
    },
  },
  created(){

  }
};
</script>

<style scoped lang=less>
body{
  background-color:gray
}
</style>